import React from 'react';
import { CalendarViewDay } from './CalendarViewDay/CalendarViewDay';
import { SimpleSailing, SimpleSailingDay } from '@go-shared/types/sailing';

interface CalendarViewWeekProps {
  sailing: SimpleSailing;
  selectedMonth: number;
  onContentBuilderClick: (sailing: SimpleSailing, sailingDay: SimpleSailingDay) => void;
  onRundownClick: (sailing: SimpleSailing, sailingDay: SimpleSailingDay) => void;
  onSailingDayLock: (sailing: SimpleSailing, sailingDay: SimpleSailingDay) => void;
  onSailingDayStar: (sailing: SimpleSailing, sailingDay: SimpleSailingDay) => void;
  onSailingDayTemplateClick: (sailing: SimpleSailing, sailingDay: SimpleSailingDay) => void;
}
export const CalendarViewWeek: React.FC<CalendarViewWeekProps> = ({
  sailing,
  selectedMonth,
  onContentBuilderClick,
  onRundownClick,
  onSailingDayLock,
  onSailingDayStar,
  onSailingDayTemplateClick,
}) => {
  return (
    <div className="CalendarWeek flex w-full">
      {sailing.days.map((day, i) => {
        return (
          <CalendarViewDay
            selectedMonth={selectedMonth}
            key={i}
            day={day}
            sailing={sailing}
            onSailingDayLock={onSailingDayLock}
            onRundownClick={onRundownClick}
            onContentBuilderClick={onContentBuilderClick}
            onSailingDayStar={onSailingDayStar}
            onSailingDayTemplateClick={onSailingDayTemplateClick}
          />
        );
      })}
    </div>
  );
};
